// extracted by mini-css-extract-plugin
var _1 = "DefaultForm_color__0fd14";
var _2 = "DefaultForm_delimiter__b5da8";
var _3 = "DefaultForm_group__0c31f";
var _4 = "DefaultForm_root__c8038";
var _5 = "DefaultForm_symbols__27f99";
export { _1 as "color", _2 as "delimiter", _3 as "group", _4 as "root", _5 as "symbols" }
